import { render } from "./RulePopup.vue?vue&type=template&id=e2f93a78&scoped=true"
import script from "./RulePopup.vue?vue&type=script&lang=js"
export * from "./RulePopup.vue?vue&type=script&lang=js"

import "./RulePopup.vue?vue&type=style&index=0&id=e2f93a78&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f93a78"]])

export default __exports__